import { SmartEditConfig } from './smart-edit-config';

export const defaultSmartEditConfig: SmartEditConfig = {
  smartEdit: {
    storefrontPreviewRoute: 'cx-preview',
    allowOrigin: 'localhost:9002',
  },
};
